import { Component } from 'vue';
import { ModelType } from '@/modules/core/app/constants/ModelType';
import SpotlightEstateGroup from '@/modules/spotlight/components/stateful/SpotlightEstateGroup.vue';
import SpotlightDocumentGroup from '@/modules/spotlight/components/stateful/SpotlightDocumentGroup.vue';
import SpotlightAssetGroup from '@/modules/spotlight/components/stateful/SpotlightAssetGroup.vue';
import SpotlightLiabilityGroup from '@/modules/spotlight/components/stateful/SpotlightLiabilityGroup.vue';

export default class SpotlightGroupComponentFactory {
  static build(type: string): Component | null {
    switch (type) {
      case ModelType.ESTATE:
        return SpotlightEstateGroup;
      // case ModelType.ESTATE_ACCOUNT:
      //   return SpotlightMemberGroup;
      case ModelType.DOCUMENT:
        return SpotlightDocumentGroup;
      case ModelType.ASSET:
        return SpotlightAssetGroup;
      case ModelType.LIABILITY:
        return SpotlightLiabilityGroup;
      default:
        return null;
    }
  }
}
